import { DeleteOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Empty, Flex, Form } from "antd"
import React from "react"

import { DocumentCard } from "./DocumentCard.tsx"
import { type DocumentFormData } from "./document.types.ts"
import { TextInput } from "../Input/TextInput.tsx"

interface DocumentListSectionProps {
  title: string
  name: keyof Omit<DocumentFormData, "visible_blocks">
  // defaultItems?: string[]
  infoFieldName?: string[]
  infoPlaceholder?: string
  itemPlaceholder?: string
  addButtonText?: string
  bulletChar?: string
}

export function DocumentListSection({
  title,
  name,
  // defaultItems = [],
  infoFieldName,
  infoPlaceholder,
  itemPlaceholder = "Enter item",
  addButtonText = "Item",
  bulletChar = "•"
}: DocumentListSectionProps) {
  return (
    <DocumentCard title={title} name={name}>
      {infoFieldName && (
        <Form.Item name={infoFieldName}>
          <TextInput placeholder={infoPlaceholder} />
        </Form.Item>
      )}

      <Form.List name={name}>
        {(fields, { add, remove }) => (
          <>
            {fields?.length ? (
              fields.map(({ key, ...field }) => (
                <Flex gap={3} key={key} className="pb-2" align="center">
                  <span className={"text-lg"}>{bulletChar}</span>
                  <Form.Item
                    {...field}
                    className="flex-1 mb-0"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: "Please enter text"
                      }
                    ]}
                  >
                    <TextInput placeholder={itemPlaceholder} />
                  </Form.Item>
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => remove(field.name)}
                  />
                </Flex>
              ))
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
            <Button
              className="w-full"
              type="dashed"
              onClick={() => add()}
              icon={<PlusOutlined />}
            >
              {addButtonText}
            </Button>
          </>
        )}
      </Form.List>
    </DocumentCard>
  )
}
